import styled from "styled-components";
import { spacings } from "../theme";

export const ViewContainer = styled.div`
    margin: 0 auto;
    max-width: 1280px;
    margin-bottom: ${spacings.standardSpacing};
    padding-bottom: ${spacings.narrow};
`;
